import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators';
import { keyed } from 'lit/directives/keyed';

import { TopicCategory } from '../../types';

@customElement('category-pill')
export class CategoryPill extends LitElement {
    @property({ type: Object })
    value?: TopicCategory;

    @property({ type: Boolean })
    checked: boolean = false;

    private handleClick(e: Event) {
        this.dispatchEvent(
            new CustomEvent('select', {
                detail: this.value?._id?.$oid,
            })
        );
    }

    protected render() {
        const containerClass = `pillItem${this.checked ? ' selected' : ''}`;
        const selectedIconClass = `selectedIcon${this.checked ? '' : ' displayNone'}`;
        const pillIconClass = this.checked ? 'displayNone' : '';

        return html`
            <div class=${containerClass} @click=${this.handleClick}>
                <div class=${selectedIconClass}>
                    <mwc-icon>check</mwc-icon>
                </div>
                <img
                    src="${this.value?.icon}"
                    class=${pillIconClass}
                    width="20"
                    height="20"
                    alt="pill-icon"
                    onerror="this.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='"
                />
                ${keyed(this.value?.name, html`<translated-span class="pillTitle">${this.value?.name}</translated-span>`)}
            </div>
        `;
    }

    static get styles() {
        return css`
            .pillItem {
                display: flex;
                align-items: center;
                padding: 2px 4px;
                background: transparent;
                border: 2px solid var(--theme-border-color);
                border-radius: 40px;
                font-size: 12px;
                font-weight: 500;
                cursor: pointer;
                margin-right: 0.25rem;
                margin-bottom: 0.25rem;
            }

            .pillItem.selected {
                background: var(--main-primary-color);
                color: var(--theme-white-color);
            }

            .pillTitle {
                padding: 0 0.75rem;
            }

            .selectedIcon {
                border: 2px solid var(--theme-white-color);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            mwc-icon {
                --mdc-icon-size: 1rem;
            }

            .displayNone {
                display: none;
            }
        `;
    }
}
